export default async function mediaQueries() {
  return Promise.all([
    preferredColorScheme(),
    invertedColors(),
    forcedColors(),
    prefersContrast(),
    prefersReducedMotion(),
    prefersReducedTransparency(),
    prefersReducedData(),
    dynamicRange(),
    colorGamut(),
    monochrome(),
    pointerCoarse(),
    anyHoverHover(),
    hoverNone(),
  ]).then((values) => {
    return {
      preferredColorScheme: values[0],
      invertedColors: values[1],
      forcedColors: values[2],
      prefersContrast: values[3],
      prefersReducedMotion: values[4],
      prefersReducedTransparency: values[5],
      prefersReducedData: values[6],
      dynamicRange: values[7],
      colorGamut: values[8],
      monochrome: values[9],
      pointerCoarse: values[10],
      anyHoverHover: values[11],
      hoverNone: values[12],
    };
  });
}

async function preferredColorScheme() {
  if (matchMedia('(prefers-color-scheme: light)').matches) return 'light';
  if (matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
  return null;
}

async function invertedColors() {
  if (matchMedia('(inverted-colors: inverted)').matches) return 'inverted';
  if (matchMedia('(inverted-colors: none)').matches) return 'none';
  return null;
}

async function forcedColors() {
  if (matchMedia('(forced-colors: active)').matches) return 'active';
  if (matchMedia('(forced-colors: none)').matches) return 'none';
  return null;
}

async function prefersContrast() {
  if (matchMedia('(prefers-contrast: no-preference)').matches) return 'no-preference';
  if (matchMedia('(prefers-contrast: high)').matches) return 'high';
  if (matchMedia('(prefers-contrast: more)').matches) return 'more';
  if (matchMedia('(prefers-contrast: low)').matches) return 'low';
  if (matchMedia('(prefers-contrast: less)').matches) return 'less';
  if (matchMedia('(prefers-contrast: forced)').matches) return 'forced';
  return null;
}

async function prefersReducedMotion() {
  if (matchMedia('(prefers-reduced-motion: no-preference)').matches) return 'no-preference';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return 'reduce';
  return null;
}

async function prefersReducedTransparency() {
  if (matchMedia('(prefers-reduced-transparency: no-preference)').matches) return 'no-preference';
  if (matchMedia('(prefers-reduced-transparency: reduce)').matches) return 'reduce';
  return null;
}

async function prefersReducedData() {
  if (matchMedia('(prefers-reduced-data: no-preference)').matches) return 'no-preference';
  if (matchMedia('(prefers-reduced-data: reduce)').matches) return 'reduce';
  return null;
}

async function dynamicRange() {
  if (matchMedia('(dynamic-range: high)').matches) return 'high';
  if (matchMedia('(dynamic-range: standard)').matches) return 'standard';
  return null;
}

async function colorGamut() {
  if (matchMedia('(color-gamut: rec2020)').matches) return 'rec2020';
  if (matchMedia('(color-gamut: p3)').matches) return 'p3';
  if (matchMedia('(color-gamut: srgb)').matches) return 'srgb';
  return null;
}

async function monochrome() {
  if (matchMedia('(monochrome: 0)').matches) return 0;
  return 1;
}

async function pointerCoarse() {
  if (matchMedia('(pointer: coarse)').matches) return true;
  return false;
}

async function anyHoverHover() {
  if (matchMedia('(any-hover: hover)').matches) return true;
  return false;
}

async function hoverNone() {
  if (matchMedia('(hover: none)').matches) return true;
  return false;
}
